/* eslint-disable import/no-webpack-loader-syntax */

import 'symbol-observable';
import './logger.js';
import '!style-loader!css-loader!Styles/normalizer.css';
import '!style-loader!css-loader!Styles/resets.css';

import React from 'react';
import { createRoot } from 'react-dom/client';

import { Provider } from 'react-redux';

import store from './configureStore.js';
import Reader from './components/Reader';

import checkCookie from './cookie.js';


checkCookie();

createRoot(document.getElementById('root-entry')).render(
    <Provider store={ store }>
      <Reader />
    </Provider>
);

// Handle hot reloading requests from Webpack
if (module.hot) {
  module.hot.accept('./components/Reader', () => {
    //If we receive a HMR request for our App container, then
    //reload it using require (we can't do this dynamically with import)
    const NextApp = require('./components/Reader').default;

    // And render it into the root element again
    createRoot(document.getElementById('root-entry')).render(
        <Provider store={ store }>
          <NextApp />
        </Provider>
    );
  });

  module.hot.accept('./reducers', () => {
    const newReducer = require('./reducers').default;
    store.replaceReducer(newReducer);
  });
}
